export default __webpack_public_path__ + "images/fb0394495eef33757bbbfc6b560dab6b.jpg";